<template>
  <div class="base-card-to-listen">
    <base-card>
      <!-- <p class="eae-title">{{title}}</p> -->
      <base-question
        :text="title"
        :class="sizes.length > 1 ? 'mb_25' : 'mb_25'"
      />

      <div
        v-for="(element, elementIndex) in elements"
        :key="elementIndex"
        :class="elementIndex > 0 ? 'size-with-border' : ''"
      >
        <div v-if="sizes.length > 1" class="d-flex align-center mb_10">
          <base-input
            :ref="`nameInput${elementIndex}`"
            :label="elementPlaceholder"
            v-model="element.name"
            class="mb_5 p_0 mr_15 w-100"
          />
          <base-button
            class="remove-btn mb_5"
            design="four"
            @click.prevent="deleteItem(element)"
          >
            <i class="fal fa-times"></i>
          </base-button>
        </div>

        <div class="mb_20">
          <div
            v-for="(elementSize, sizeIdx) in getSizesByElement(element)"
            :key="sizeIdx"
          >
            <!-- v-for pra cada tamanho -->
            <div class="d-flex align-center mb_5-negative">
              <base-box sortBox class="d-flex align-center mt_10 mr_10 w-100 fs-12">
                <p>{{ elementSize.name }}</p>
              </base-box>
              <div class="wpx-min-120 wpx-120">
                <base-input
                  :type="'tel'"
                  v-model="elementSize.price"
                  class="pl_5 mb_5"
                  :money-mask="StringLanguage.currencyConfigs"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="w-100 d-flex mt_20">
        <base-button
          :text="addButtonText"
          design="two"
          class="w-100 mr_5"
          @click.prevent="addNewItem"
        />
      </div>
    </base-card>
  </div>
</template>

<script>
import BaseCard from "@/components/Card";
import BaseInput from "@/components/Input";
import BaseButton from "@/components/Button";
import BaseQuestion from "@/components/Question";
import BaseBox from "@/components/Box";

export default {
  components: {
    BaseCard,
    BaseInput,
    BaseButton,
    BaseQuestion,
    BaseBox,
  },

  props: {
    title: { type: String },
    elementPlaceholder: { type: String },
    addButtonText: { type: String, default: "Adicionar" },
    finishButtonText: { type: String, default: "Concluir" },
    deleteMode: { type: Boolean, default: false },
    sizes: { type: Array, default: [] },
    elements: { type: Array, default: [] },
  },
  data() {
    return {};
  },
  updated() {
    const refKeys = Object.keys(this.$refs);

    refKeys.forEach((inputRef) => {
      if (inputRef.includes("nameInput")) {
        if (this.$refs[inputRef] && this.$refs[inputRef].length > 0) {
          if (this.$refs[inputRef][0].value === "") {
            this.$refs[inputRef][0].focus();

            const priceInputRef = `priceInput${inputRef.replace(
              "nameInput",
              ""
            )}`;
            this.$refs[priceInputRef] &&
              this.$refs[priceInputRef].length > 0 &&
              (this.$refs[priceInputRef][0].value = 0);
          }
        }
      }
    });
  },
  methods: {
    getSizesByElement(element) {
      return this.$props.sizes.map((s) => {
        let matchSize = element.getItemsByParam("_id", s._id);
        return matchSize.length > 0 ? matchSize[0] : s;
      });
    },
    checkSizeName(name) {
      if (name === "") alert("Você não configurou o nome dos tamanhos.");
    },
    applyPrice(size, price) {},
    onChanged() {
      //Emitir evento de alteração
    },
    addNewItem() {
      this.$emit("addNewItem");
    },
    deleteItem(elm) {
      this.$emit("removeElement", elm);
      return false;
    },
    toggleDeleteMode(activate) {
      this.$emit("deleteMode", activate);
    },
  },
};
</script>
<style scoped>
.remove-btn {
  font-size: 1.2em;
  min-width: 50px;
  width: 50px;
  min-height: 45px;
}
.size-with-border {
  border-top: 2px solid #777777 !important;
  padding-top: 25px;
}
.mb_5-negative {
  margin-bottom: -5px;
}
</style>